import React from 'react';
import LookerReport from './LookerReport';

const PagesViewAnalytics = () => {
  return <LookerReport source="pages_view" title="Pages View Analytics" />;
};

export default PagesViewAnalytics;